import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS } from '../../../../middlewares/api/actions';
import {
  FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ,
  FILE_MAPPING_LIST_FILE_MAPPING_DELETE,
  FILE_MAPPING_LIST_FILE_MAPPING_DELETE_ALL,
  FILE_MAPPING_LIST_FILE_MAPPING_HIDE,
  FILE_MAPPING_LIST_FILE_MAPPING_READ,
  FILE_MAPPING_LIST_FILE_MAPPING_SHOW,
  FILE_MAPPING_LIST_FILE_MAPPINGS_READ
} from './actions';
import { FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE } from '../wizard/actions';
import {getCubesTree} from "../../../../utils/treeBuilders";
import {
  getCategorisedObjectsTree,
  getFilteredTreeWithPaths,
  getMappedTree
} from "../../../../utils/tree";

const fileMappingListReducer = (
  state = {
    fileMappingsTree: null,
    fileMappingId: null,
    fileMapping: null,
    fileMappingCube: null
  },
  action
) => {
  switch (action.type) {
    case FILE_MAPPING_LIST_FILE_MAPPING_SHOW:
      return {
        ...state,
        fileMappingId: action.fileMappingId
      };
    case FILE_MAPPING_LIST_FILE_MAPPING_HIDE:
      return {
        ...state,
        fileMappingId: null,
        fileMapping: null,
        fileMappingCube: null
      };
    case REQUEST_START:
      switch (action.label) {
        case FILE_MAPPING_LIST_FILE_MAPPINGS_READ:
          return {
            ...state,
            fileMappingsTree: null
          };
        case FILE_MAPPING_LIST_FILE_MAPPING_READ:
          return {
            ...state,
            fileMapping: null
          };
        case FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ:
          return {
            ...state,
            fileMappingCube: null
          };
        default:
          return state;
      }
    case REQUEST_ERROR:
      switch (action.label) {
        case FILE_MAPPING_LIST_FILE_MAPPINGS_READ:
          return {
            ...state,
            fileMappingsTree: []
          };
        case FILE_MAPPING_LIST_FILE_MAPPING_READ:
          return {
            ...state,
            fileMappingId: null,
          };
        case FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ:
          return {
            ...state,
            fileMappingId: null,
            fileMapping: null
          };
        default:
          return state;
      }
    case REQUEST_SUCCESS:
      switch (action.label) {
        case FILE_MAPPING_LIST_FILE_MAPPINGS_READ:

          const [allCubes, dcs, mappings] = action.response;

          const treeWithCategories = getCubesTree(allCubes, dcs);

          const treeWithCategoriesOrd = getMappedTree(treeWithCategories, "children", node => {
            let ordCount = 1;
            return {
              ...node,
              TreeID: node.CatCode ? `Cat_${node.CatCode}` : `${node.Code}`,
              children:
                node.children
                  ? node.children
                    .sort((a, b) => {
                      if (a.Ord !== undefined && b.Ord !== undefined) {
                        return a.Ord - b.Ord;
                      } else if (a.Ord !== undefined) {
                        return a;
                      } else if (b.Ord !== undefined) {
                        return b;
                      } else {
                        return (a.CatCode || -1) - (b.CatCode || -1);
                      }
                    })
                    .map(c => ({
                      ...c,
                      Ord: c.Ord !== undefined ? String(ordCount++) : undefined
                    }))
                  : node.children
            };
          });

          const treeWithMappings = getCategorisedObjectsTree(
            mappings.map(mapping => ({
              ...mapping,
              TreeID: `Mapp_${mapping.IDMapping}`
            })),
            treeWithCategoriesOrd,
            "children",
            (a, b) => a.IDMapping - b.IDMapping,
            (mapping, cube) => {
              if (cube) {
                return cube.IDCube === mapping.IDCube;
              } else {
                return true;
              }
            },
            null,
            null,
            true
          );

          const cleanedTreeWithMappings = getFilteredTreeWithPaths(
            treeWithMappings,
            "children",
            node =>
              node.IDMapping ||
              (node.children && node.children.filter(({IDMapping}) => IDMapping).length > 0)
          );

          return {
            ...state,
            fileMappingsTree: cleanedTreeWithMappings
          };
        case FILE_MAPPING_LIST_FILE_MAPPING_READ:
          return {
            ...state,
            fileMapping: action.response
          };
        case FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ:
          return {
            ...state,
            fileMappingCube: action.response
          };
        case FILE_MAPPING_LIST_FILE_MAPPING_DELETE:
        case FILE_MAPPING_LIST_FILE_MAPPING_DELETE_ALL:
          return {
            ...state,
            fileMappings: null,
            fileMappingsTree: null
          };
        case FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE:
          return {
            ...state,
            fileMappings: null,
            fileMappingsTree: null
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

export default fileMappingListReducer;



// WEBPACK FOOTER //
// ./src/scenes/data-manager/file-mapping/list/reducer.js